
import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

export const LoadingPlans: React.FC = () => {
  console.log("Rendering LoadingPlans component");
  
  return (
    <div className="space-y-8">
      <div className="bg-white dark:bg-gray-800/60 rounded-xl p-6 mb-8 grid grid-cols-1 md:grid-cols-3 gap-6 border border-gray-100 dark:border-gray-700/50 shadow-sm">
        {[1, 2, 3].map((index) => (
          <div key={index} className="flex items-center gap-4">
            <Skeleton className="w-10 h-10 rounded-full" />
            <div>
              <Skeleton className="h-4 w-32 mb-1" />
              <Skeleton className="h-5 w-24" />
            </div>
          </div>
        ))}
      </div>
    
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {[1, 2, 3].map((index) => (
          <div key={index} className="bg-white dark:bg-gray-800/60 rounded-xl p-6 border border-gray-100 dark:border-gray-700/50 h-full">
            <Skeleton className="h-6 w-32 mb-2" />
            <Skeleton className="h-4 w-48 mb-4" />
            <Skeleton className="h-10 w-24 mb-6" />
            <Skeleton className="h-8 w-full mb-6" />
            <div className="space-y-3">
              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="flex items-center gap-2">
                  <Skeleton className="h-4 w-4 rounded-full" />
                  <Skeleton className="h-4 w-48" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
